import {system} from 'services/objects';

const {
  CONFIG_PARAMS: {GOOGLE, FACEBOOK, LINKEDIN},
  FONTAWESOME: {FA_GOOGLE, FA_FACEBOOK, FA_LINKEDIN},
} = system;
/**
 *
 * @param linkTo {string}
 * @param socialClasses {string}
 * @param fontawesome {string}
 */
const socialButton = ({linkTo = '#', socialClasses, fontawesome}) => {
  switch (fontawesome) {
    case FACEBOOK:
      return (
        <a href={linkTo} className={socialClasses}>
          <i className={FA_FACEBOOK} />
        </a>
      );
    case LINKEDIN:
      return (
        <a href={linkTo} className={socialClasses}>
          <i className={FA_LINKEDIN} />
        </a>
      );
    case GOOGLE:
    default:
      return (
        <a href={linkTo} className={socialClasses}>
          <i className={FA_GOOGLE} />
        </a>
      );
  }
};

export default socialButton;
